<section class="my-6 w-100">
  <h2 class="title-t1 mb-5 ml-6" data-test="organizationCustomFieldsTitle">{{'customFieldDefinitions.title' | translate}}</h2>
  <p class="body-b2 mb-5 ml-6">{{'customFieldDefinitions.subtitle' | translate}}</p>
  <p class="body-b2 mb-5 ml-6 secondary-text">{{'customFieldDefinitions.description' | translate}}</p>

  <mat-tab-group class="ml-6" (selectedTabChange)="selectTarget(TARGETS[$event.index])">
    <mat-tab *ngFor="let target of TARGETS" label="{{('customFieldDefinitions.targets.' + target) | translate}}">

      <div class="mt-4">
        <div *ngIf="loading" class="flex justify-center py-8">
          <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
        </div>

        <ng-container *ngIf="!loading">
          <p *ngIf="!active.length && !archived.length" class="body-b2 secondary-text py-4" data-test="customFieldDefinitionsEmpty">
            {{'customFieldDefinitions.empty' | translate}}
          </p>

          <div *ngIf="active.length" class="shadow-standard border-tb" cdkDropList (cdkDropListDropped)="drop($event)">
            <div *ngFor="let definition of active" cdkDrag class="flex items-center py-3 px-4 border-b" data-test="customFieldDefinitionRow">
              <mat-icon cdkDragHandle svgIcon="menu" class="cursor-move mr-3" data-test="customFieldDefinitionDragHandle"></mat-icon>

              <div class="flex-1 flex items-center">
                <span class="body-b2 w-1/5 mr-2 flex items-center">
                  {{definition.label}}
                  <mat-icon *ngIf="definition.alwaysShow" svgIcon="eye" class="ml-2" [matTooltip]="'customFieldDefinitions.alwaysShow' | translate" data-test="customFieldDefinitionAlwaysShowIndicator"></mat-icon>
                </span>
                <span class="caption-c1 secondary-text w-1/5 mr-2">{{definition.key}}</span>
                <span class="caption-c1 secondary-text w-1/5 mr-2">{{('customField.dataTypes.' + definition.dataType) | translate}}</span>
                <span class="caption-c1 secondary-text w-1/5 mr-2">
                  <ng-container *ngIf="selectedTarget === TARGET.Actor">
                    {{actorSubtypesLabel(definition) || ('customFieldDefinitions.allActorSubtypes' | translate)}}
                  </ng-container>
                  <ng-container *ngIf="definition.dataType === DATA_TYPE.Select">
                    {{optionsLabel(definition)}}
                  </ng-container>
                </span>
              </div>

              <app-button-link iconLeft="edit-2" text="{{'buttons.edit' | translate}}" [style]="'primary'" (click)="edit(definition)" class="mr-2" data-test="editCustomFieldDefinition"></app-button-link>
              <app-button-link iconLeft="archive" text="{{'customFieldDefinitions.archive' | translate}}" [style]="'warn'" (click)="archive(definition)" data-test="archiveCustomFieldDefinition"></app-button-link>
            </div>
          </div>

          <div *ngIf="archived.length" class="mt-6">
            <h3 class="caption-c1 secondary-text mb-2">{{'customFieldDefinitions.archivedTitle' | translate}}</h3>
            <div class="shadow-standard border-tb">
              <div *ngFor="let definition of archived" class="flex items-center py-3 px-4 border-b secondary-text" data-test="customFieldDefinitionRow">
                <span class="body-b2 w-1/5 mr-2">{{definition.label}}</span>
                <span class="caption-c1 w-1/5 mr-2">{{definition.key}}</span>
                <span class="caption-c1 w-1/5 mr-2">{{('customField.dataTypes.' + definition.dataType) | translate}}</span>
                <span class="flex-1"></span>
                <app-button-link iconLeft="unarchive" text="{{'customFieldDefinitions.unarchive' | translate}}" [style]="'primary'" (click)="unarchive(definition)" data-test="unarchiveCustomFieldDefinition"></app-button-link>
              </div>
            </div>
          </div>

          <div class="mt-6">
            <app-button-link iconLeft="plus-circle" text="{{'customFieldDefinitions.new' | translate}}" [style]="'primary'" (click)="openNew()" data-test="newCustomFieldDefinition"></app-button-link>
          </div>
        </ng-container>
      </div>

    </mat-tab>
  </mat-tab-group>
</section>
